import { useEffect, useState } from "react";

const KEY = "ui_mode";
const EVT = "ui-mode-change";

export function useUiMode() {
  const [mode, setMode] = useState(() => localStorage.getItem(KEY) || "");
  useEffect(() => {
    const on = () => setMode(localStorage.getItem(KEY) || "");
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  const set = (m) => { localStorage.setItem(KEY, m); window.dispatchEvent(new Event(EVT)); };
  return [mode, set];
}
